import { RcFile } from 'antd/es/upload';
import { ExtraRcFile } from 'models/file';

export const generateFileWithThumbnail = async (file: RcFile): Promise<ExtraRcFile> => {
  const videoUrl = URL.createObjectURL(file);
  (file as ExtraRcFile).preview = videoUrl;

  const video = document.createElement('video');
  video.src = videoUrl;
  video.currentTime = 1;
  video.muted = true;

  return new Promise((resolve) => {
    video.addEventListener('loadeddata', () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth / 2;
      canvas.height = video.videoHeight / 2;

      setTimeout(() => {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const thumbnailBlobUrl = canvas.toDataURL('image/png');
          (file as ExtraRcFile).thumbUrl = thumbnailBlobUrl;

          canvas.toBlob((blob) => {
            if (blob) {
              (file as ExtraRcFile).thumbFile = new File([blob], 'image.png', { type: 'image/png' });
            }
            resolve(file);
          }, 'image/png');

          // if (fileWithThumbnail?.preview) {
          //   URL.revokeObjectURL(fileWithThumbnail.preview);
          // }
        } else {
          resolve(file);
        }
      }, 50);
    });
  });
};
